import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../../utils/request';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import MultiSelect from './multiSelect';

const FilterBySalesRep = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterBySalesRep }
  } = localizedStrings;
  const [salesRepList, setSalesRepList] = useState([]);

  useEffect(() => {
    const getSalesRepsList = async () => {
      const result = await request.get('/salesRepUsers');
      if (result) {
        const transformedResult = _.get(result, 'data', []).map(item => ({
          label: item.name,
          value: item.email
        }));
        setSalesRepList(transformedResult);
      }
    };
    getSalesRepsList();
  }, []);

  return (
    <div>
      <MultiSelect
        label={filterBySalesRep}
        options={salesRepList}
        value={filters.createdBy}
        updateFilters={value => {
          setFilters({ ...filters, createdBy: value });
        }}
      />
    </div>
  );
};

FilterBySalesRep.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterBySalesRep;
